window.CKEDITOR_BASEPATH = `${window.__HB_ENV__.PUBLIC_PATH}vendor/ckeditor/`;
window.CKEDITOR_EMBED_PROVIDER = `${window.location.origin}${Routes.backoffice_embed_index_path()}?url={url}&callback={callback}&maxwidth=550`;
